// extracted by mini-css-extract-plugin
module.exports = {"container":"_387Dy","small":"_21Mbm","triangle":"_2mFWf","top":"_2ldNP"};